<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><a href="#/OEBPS/toc.htm#als">Also by Mark Billingham</a></p>
<p class="center1"><em>The DI Tom Thorne series</em></p>
<p class="center0">Sleepyhead</p>
<p class="center0">Scaredy Cat</p>
<p class="center0">Lazybones</p>
<p class="center0">The Burning Girl</p>
<p class="center0">Lifeless</p>
<p class="center0">Buried</p>
<p class="center0">Death Message</p>
<p class="center0">Bloodline</p>
<p class="center0">From the Dead</p>
<p class="center0">The Demands (<em>published as</em> Good as Dead <em>in the United Kingdom</em>)</p>
<p class="center0">The Dying Hours</p>
<p class="center0">The Bones Beneath</p>
<p class="center0">Time of Death</p>
<p class="center1"><em>Other fiction</em></p>
<p class="center0">In the Dark</p>
<p class="center0">Die of Shame</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// als.vue?1bc3cfb8